export default "__VITE_ASSET__xeY17Vgl__"